module.exports = __webpack_public_path__ + "img/Adolfo Merchand_Asesor Comercial.62ad671e.png";